import { db } from '@/firebase'

export default {
  getCupones({ commit, rootState }) {
    let negocio = rootState.app.negocioGest;
    let devolver = [];
    return db.collection('negocios').doc(negocio).collection('cupones').get()
      .then((res) => {
        // res.forEach(doc => {
        //   let aux = doc.data();
        //   aux.id = doc.id;
        //   devolver.push(aux);
        // });
        commit('setCupones', res.docs.map(c => {
          return {
            ...c.data(),
            id: c.id
          }
        }))
      })
  },
  addCupon({ rootState }, desc) {
    let negocio = rootState.app.negocioGest
    let id = desc.id;
    delete desc.id;
    var ref = null
    if (id) {
      ref = db.collection('negocios').doc(negocio).collection('cupones').doc(id).set(desc, { merge: true })
    } else {
      ref = db.collection('negocios').doc(negocio).collection('cupones').add(desc)
    }
    return ref;
  },
  deleteCupon({ commit, rootState }, item) {
    let negocio = rootState.app.negocioGest;
    return db.collection('negocios').doc(negocio).collection('cupones').doc(item.id).delete();
  },
}